const SUPPORTED_SOCIAL_IDPS = ['facebook', 'google', 'linkedin', 'microsoft', 'apple', 'github', 'gitlab', 'yahoo', 'line', 'paypal', 'paypal_sandbox', 'salesforce', 'amazon', 'yahoojp', 'discord', 'adobe', 'orcid', 'spotify', 'xero', 'quickbooks'];
var IDP = {
  SUPPORTED_SOCIAL_IDPS: SUPPORTED_SOCIAL_IDPS
};

export { IDP as default };
//# sourceMappingURL=IDP.js.map
